export const SNACKBAR_MESSAGE_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  ERROR_CUSTOM: "error_custom",
};

export const SNACKBAR_MARKER = {
  INSPECTION_PLANNING: "inspectionPlanning",
  PERSERVATION_REHAB: "preservationRehab",
  INVENTORY_FEATURES: "inventoryFeatures",
  TUNNELS: "tunnel",
  WALLS: "walls",
  SIGN_AND_LIGHTS: "signAndLights",
  STRUCTURE_IDENTIFICATION: "structureIdentification",
  STRUCTURE_COMPOSITION: "structureComposition",
  INSPECTION_LINK: "inspectionLink",
  APPROACH: "approach",
  LOAD_RATING_AND_POSTINGS: "loadRatingsAndPostings",
  INVENTORY_SIGNS_AND_LIGHTS: "inventorySignsAndLights",
  INVENTORY_WALLS: "inventoryWalls",
  APRAS: "apras",
  INVENTORY_TUNNELS: "inventoryTunnels",
  CULVERT: "culvert",
  RATINGS: "ratings",
  JOINTS: "joints",
  BEARINGS: "bearings",
  DECK: "deck",
  ELEMENTS: "elements",
  NSTM_FATIGUE: "nstmFatigue",
  SUBSTRUCTURE: "substructure",
  SCHEDULE: "schedule",
  NOTES: "notes",
  WATERWAY: "waterway",
  SUPERSTRUCTURE: "superstructure",
  MAINTENANCE: "maintenance",
  GLOBAL_FOREIGN_KEY_ERROR: "globalForeignKeyError",
};
